import { last, without } from 'lodash';

export const multiSelect = ({ column, selectedPages, pageId, columnId }) => {
	const indexOfNew = column.pageIds.indexOf(pageId);

	if (columnId in selectedPages === false) return { [columnId]: column.pageIds.slice(0, indexOfNew + 1) }; // Nothing already selected

	const lastSelected = last(selectedPages[columnId]);
	const indexOfLast = column.pageIds.indexOf(lastSelected);

	if (indexOfNew === indexOfLast) return;

	// multi selecting in the same column
	// need to select everything between the last index and the current index inclusive
	const isSelectingForwards = indexOfNew > indexOfLast;
	const start = isSelectingForwards ? indexOfLast : indexOfNew;
	const end = isSelectingForwards ? indexOfNew : indexOfLast;
	const inBetween = column.pageIds.slice(start, end + 1);

	// everything inbetween needs to have it's selection toggled.
	// with the exception of the start and end values which will always be selected
	const toAdd = without(inBetween, ...selectedPages[columnId]);
	const sorted = isSelectingForwards ? toAdd : [...toAdd].reverse();
	const combined = [...selectedPages[columnId], ...sorted];

	return {
		...selectedPages,
		[columnId]: combined,
	};
};
